import { setTempState } from '@starflow/app/store';

export const playVideo = (videoPlayerData) => {
  setTempState({ videoPlayerData, exclusiveWindow: 'video-player' });
};
